import { useEffect, type ReactNode } from 'react'

export default function FormModal({ title, subtitle, children, onClose, size = 'lg' }: { title: string; subtitle?: string; children: ReactNode; onClose: () => void; size?: 'md' | 'lg' | 'xl' }) {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose() }
    document.addEventListener('keydown', closeOnEscape)
    document.body.classList.add('modal-open')
    return () => { document.removeEventListener('keydown', closeOnEscape); document.body.classList.remove('modal-open') }
  }, [onClose])

  return <div className="crud-modal" role="presentation" onMouseDown={event => { if (event.target === event.currentTarget) onClose() }}>
    <section className={`crud-modal-dialog modal-${size}`} role="dialog" aria-modal="true" aria-labelledby="crud-modal-title">
      <header className="crud-modal-header">
        <div><p className="eyebrow">Record management</p><h2 id="crud-modal-title">{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
        <button className="crud-modal-close" type="button" onClick={onClose} aria-label="Close"><i className="bi bi-x-lg" /></button>
      </header>
      <div className="crud-modal-body">{children}</div>
    </section>
  </div>
}
